<div class="h-screen w-full bg-bg_primary flex flex-col items-center justify-center gap-8 p-8">
    <!-- Animated Logo Spinner -->
    <div class="relative w-32 h-32">
        <svg class="w-full h-full animate-spin" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">

            <!-- Inner Icon -->
            <path fill="var(--primary)"
                  d="M50 15L62.5 40H37.5L50 15ZM50 85L37.5 60H62.5L50 85ZM15 50L40 62.5V37.5L15 50ZM85 50L60 37.5V62.5L85 50Z"
                  class="animate-scale-in"/>

            <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stop-color="var(--primary)" />
                    <stop offset="100%" stop-color="var(--green)" />
                </linearGradient>
            </defs>
        </svg>
    </div>

    <!-- Animated Text -->
    <div class="text-center space-y-4">
        <h1 class="text-button-primary text-32 font-bold animate-fade-in">
            Redirecting...
        </h1>
    </div>

    <!-- Progress Bar -->
    <div class="w-64 h-2 bg-input rounded-full overflow-hidden">
        <div class="h-full bg-primary animate-progress"></div>
    </div>
</div>